import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/clock.svg")